import axios from "axios";

export const submitEnquiry = (request: SubmitEnquiryRequestType): Promise<EnquiryResponse | null> => {
    return axios.post(
        '/api/easydirectoryapi/submit-enquiry',
        JSON.stringify(request),
        {
            headers: { 'Content-Type': 'application/json' }
        }
    )
    .then((response) => {
        if(response.status === 200) {
            return response.data as EnquiryResponse;
        }

        return null;
        })
    .catch((error) => {
        if (error.response && error.response.status === 422) {
            return error.response.data as EnquiryResponse;
        }

        return null;
    })
};

export interface EnquiryResponse {
    hasError: boolean;
    errorMessage: string;
    isNewUser: boolean;
    newUserSessionId: string;
    supplierId: number;
    recordGtag: boolean;
}

export interface SubmitEnquiryRequestType {
    Name: string;
    Phone: string;
    Email: string;
    WeddingDate: string | '' | undefined; // Now expects YYYY-MM-DD format
    EngagementDate?: string | ''; // Now expects YYYY-MM-DD format
    WeddingLocation?: string;
    Comment: string;
    NumberOfGuests: number | '' | undefined;
    UserAgent: string;
    BookedVenueSupplierID?: string | '';
    BookedVenueSupplierName?: string | '';

    SupplierEmail: string;
    SupplierId: number;
    CategoryId: number;
    RegionId: number | '';
    Brochure: boolean;
    NominatedDates: string;
    Price: boolean;
    Availability: boolean;
    SupplierName: string;
    EnquiryType: number;
    IsLongForm: boolean;
    CategorySlug: string;
    IsPpa: boolean;
    EnquirySource: string;
}